// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1o_rM","title":"AfterFrontImage_title__5bAgq"};